import { useAppDispatch, useAppSelector } from 'app/hooks';
import { ChatMessageType } from 'models/chatMessage';
import { clearReplyMessage, selectReplyMessage, setReplyMessage } from 'redux/chatSlice';

const useReplyMessage = () => {
  const dispatch = useAppDispatch();

  const replyMessage = useAppSelector(selectReplyMessage);
  const setMessageToReply = (message: ChatMessageType) => {
    dispatch(setReplyMessage(message));
  };

  const clearMessage = () => {
    dispatch(clearReplyMessage());
  };

  return {
    replyMessage,
    setMessageToReply,
    clearMessage,
  };
};

export default useReplyMessage;
